<template>
  <div class="page">
    <div class='top'>
      <div class="title">温馨提醒</div>
      <div class="top-tip">请完善学生的联系电话，完善后即可享受系统的科普宣教、复诊等通知服务</div>
    </div>
    <div class="input-div">
      <van-field v-model="phone" type="number" clearable label="手机号" placeholder="请输入手机号" />
    </div>
    <div class="input-div">
      <van-field v-model="code" type="number" clearable label="验证码" placeholder="请输入验证码" style="width: 5rem;">
      </van-field>
      <van-button type="info" @click="getCode" class="code-btn" :disabled="isCode">
        {{ codeTxt }}
      </van-button>
    </div>


    <van-button type="info" @click="goSubmit" class="btn">
      确定
    </van-button><br />
    <van-button type="info" @click="goPass" class="btn-pass">
      跳过
    </van-button>
  </div>
</template>
<script>
export default {
  name: "query",
  data() {
    return {
      name: '',
      idCard: '',
      code: '',
      phone: '',
      stuId: '',
      openId: '',
      title: '',
      countDown: 60,
      codeTxt: '发送验证码',
      isCode: false,
    };
  },
  mounted() {
    this.stuId = this.$route.query.student_id;
    this.openId = this.$route.query.openId;
    this.getTitle();
  },
  methods: {
    async getTitle() {
      let auth = this.$createAuth(this.$md5);
      let result = await this.$http.get(this.$url.getTitle, {
        openId: this.openId,
        auth: auth.code,
        time: auth.time
      })
      if (result.message === 'Error: Miss auth parameter.') {
        this.getTitle();
      } else {
        document.title = result.data?.title
      }
    },
    async getCode() {
      if (this.phone != "") {
        let testPhone = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[0123456789]|18[0-9]|14[57]|19[0-9])[0-9]{8}$/.test(this.phone)
        if (!testPhone) {
          this.$toast("手机号填写错误！");
          return;
        }
      }
      this.isCode = true;
      this.codeTxt = '60秒后重新发送';
      await this.$http.get(this.$url.sendCode, {
        openId: this.openId,
        phone: this.phone,
        stuId: this.stuId,
      });
      let timeDown = setInterval(() => {
        this.countDown--;
        this.codeTxt = this.countDown + '秒后重新发送';
        if (this.countDown == 0) {
          window.clearInterval(timeDown);
          this.isCode = false;
          this.codeTxt = '发送验证码';
        }
      }, 1000);

      this.$toast("验证码已发送！");
    },
    async goSubmit() {
      if (this.phone == "") { this.$toast("请填写手机号！"); return; }
      if (this.code == "") { this.$toast("请填写验证码！"); return; }
      if (this.phone != "") {
        let testPhone = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[0123456789]|18[0-9]|14[57]|19[0-9])[0-9]{8}$/.test(this.phone)
        if (!testPhone) {
          this.$toast("手机号填写错误！");
          return;
        }
      }
      let result = await this.$http.get(this.$url.doSetPhone, {
        openId: this.openId,
        phone: this.phone,
        code: this.code,
        studentId: this.$route.query.student_id
      });
      if (result.success) {
        this.$toast("绑定手机号成功！");
        this.$router.push(`/record?cname=${this.$route.query.clazzName}&tid=${this.$route.query.tid}&sid=${this.$route.query.sid}&openId=${this.$route.query.openId}&hospitalId=${this.$route.query.hospitalId}&studentIds=${this.$route.query.studentIds}`);
      } else {
        this.$toast(result.message);
      }

    },
    goPass() {
      this.$router.push(`/record?cname=${this.$route.query.clazzName}&tid=${this.$route.query.tid}&sid=${this.$route.query.sid}&openId=${this.$route.query.openId}&hospitalId=${this.$route.query.hospitalId}&studentIds=${this.$route.query.studentIds}`);
    }
  }
};
</script>
<style scope lang="less">
.page {
  height: 100vh;
  overflow: hidden;
}

.top {
  padding: 0.3rem;
  margin-bottom: 0.2rem;

  .title {
    margin-bottom: 0.3rem;
    font-size: 0.32rem;
    font-weight: bold;
  }

  .top-tip {
    text-align: left;
    line-height: 1.8em;
  }
}

.btn {
  width: 6.9rem;
  margin-top: 1rem;
  border: none;
  background: #5CC4AB;
}

.btn-pass {
  width: 6.9rem;
  // margin: 0.3rem auto 100rem;
  color: #333;
  background: #fff;
  // border: 1px solid #ddd;
  border: none;
  position: absolute; /* 绝对定位 */
  bottom: 0; /* 放置在底部 */
  left: 50%; /* 水平居中 */
  transform: translateX(-50%); /* 水平偏移以实现居中 */
}

.tip {
  padding: 0.3rem;
  text-align: left;
  color: #999;
}

.code-btn {
  height: 0.6rem;
  margin-top: 0.15rem;
  background: #5CC4AB;
  border: 0;
}

.input-div {
  display: flex;
  width: 100vw;
  height: 0.9rem;
  line-height: 0.9rem;
  border-bottom: 1px solid #eee;
}
</style>